/** @format */

import {LastCheckType} from '../types';

export const getPerCampaignFound = (check: LastCheckType, campaignId: string): number => {
  if (!check.campaignChecks?.length) return check.found;

  const campaignCheck = check.campaignChecks.find(cc => cc.campaignId === campaignId);
  return campaignCheck?.found ?? check.found;
};
